import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  && {
    font-size: 10px;
    font-weight: 600;
    color: ${colors.secondary20};
    padding: 0 3px 0 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

const MultiValueLabel = (props) => {
  return (
    <StyledWrapper {...props.innerProps}>
      {props.children}
    </StyledWrapper>
  )
}

MultiValueLabel.propTypes = {
  innerProps: PropTypes.object,
  children: PropTypes.node,
}

export default MultiValueLabel
